import { render, staticRenderFns } from "./lainamaailma.vue?vue&type=template&id=c4a59a18&"
import script from "./lainamaailma.vue?vue&type=script&lang=js&"
export * from "./lainamaailma.vue?vue&type=script&lang=js&"
import style0 from "./lainamaailma.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports